var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeWma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8555 6.56533C18.1174 6.56463 17.4098 6.27474 16.8879 5.75929C16.366 5.24385 16.0725 4.54495 16.0718 3.816V0H3.63285C2.66959 -6.56886e-08 1.74577 0.377839 1.06451 1.05043C0.383261 1.72302 0.000357955 2.6353 0 3.58667V25.216C0.00107335 26.1669 0.384292 27.0785 1.06547 27.7505C1.74664 28.4225 2.67006 28.8 3.63285 28.8H18.5639C19.041 28.8002 19.5136 28.7075 19.9545 28.5273C20.3954 28.347 20.7961 28.0828 21.1335 27.7496C21.471 27.4164 21.7387 27.0208 21.9214 26.5854C22.104 26.15 22.1981 25.6833 22.1981 25.212V6.56533H18.8555Z",
    fill: "#F68E1A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 6.56533H18.8555C18.1174 6.56463 17.4098 6.27474 16.8879 5.75929C16.366 5.24385 16.0725 4.54495 16.0718 3.816V0L22.1981 6.56533Z",
    fill: "#F68E1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8319 22.7466H7.95155C6.75414 22.7466 5.78345 23.7053 5.78345 24.8879V29.8586C5.78345 31.0412 6.75414 31.9999 7.95155 31.9999H24.8319C26.0294 31.9999 27 31.0412 27 29.8586V24.8879C27 23.7053 26.0294 22.7466 24.8319 22.7466Z",
    fill: "#F68E1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04511 28.4492V29.4186H8.02856V28.4492H9.04511Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0742 25.4092L14.1035 29.4185H12.8885L12.2405 26.7358L11.5858 29.4185H10.3708L9.40015 25.4092H10.468L10.9904 28.3132L11.7032 25.4092H12.7832L13.496 28.3132L14.0239 25.4092H15.0742Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1554 25.4375V29.4188H19.1699V26.9335L18.2965 29.4228H17.4473L16.5685 26.9282V29.4228H15.5857V25.4415H16.7858L17.8834 28.2148L18.9566 25.4415L20.1554 25.4375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.355 28.6868H21.8268L21.573 29.4188H20.5403L22.0253 25.4375H23.1566L24.6416 29.4188H23.5967L23.355 28.6868ZM23.1026 27.9495L22.5963 26.4762L22.086 27.9495H23.1026Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8827 17.5893H14.4044V11.688C14.4044 11.4903 14.3249 11.3007 14.1834 11.1609C14.0419 11.0212 13.8499 10.9426 13.6498 10.9426H9.86978C9.66963 10.9426 9.47769 11.0212 9.33616 11.1609C9.19464 11.3007 9.11513 11.4903 9.11513 11.688V17.5893H7.63013V11.1893C7.63048 10.7358 7.81313 10.3011 8.13791 9.98055C8.46269 9.66003 8.90304 9.47998 9.36218 9.47998H14.1425C14.6015 9.47998 15.0417 9.66007 15.3663 9.98063C15.6909 10.3012 15.8732 10.736 15.8732 11.1893L15.8827 17.5893Z",
    fill: "#F68E1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1305 19.3202C15.0982 19.3202 15.8828 18.5454 15.8828 17.5896C15.8828 16.6337 15.0982 15.8589 14.1305 15.8589C13.1627 15.8589 12.3782 16.6337 12.3782 17.5896C12.3782 18.5454 13.1627 19.3202 14.1305 19.3202Z",
    fill: "#F68E1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37095 19.3202C8.33872 19.3202 9.12325 18.5454 9.12325 17.5896C9.12325 16.6337 8.33872 15.8589 7.37095 15.8589C6.40318 15.8589 5.61865 16.6337 5.61865 17.5896C5.61865 18.5454 6.40318 19.3202 7.37095 19.3202Z",
    fill: "#F68E1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeWma);
export default __webpack_public_path__ + "static/media/Type=WMA.73dfee178380385018a4e9b2a881061d.svg";
export { ForwardRef as ReactComponent };